import script from "./EzHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./EzHeader.vue?vue&type=script&setup=true&lang=ts"

import "./EzHeader.vue?vue&type=style&index=0&id=2634cc45&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2634cc45"]])

export default __exports__